export default {
    host: "http://localhost:65126"
    // host: "http://localhost:9000",
};
